<template>
  <HashTag v-if="hash" :hash="hash"></HashTag>
  <ListingHome v-else></ListingHome>
</template>

<script>
// @ is an alias to /src
import HashTag from './IDs/HashTag.vue'
import ListingHome from './ListingHome.vue'

export default {
  components: {
    ListingHome,
    HashTag
  },
  computed: {
    hash () {
      return this.$route.hash
    }
  }
}
</script>
